/**
 * Inline SVG icons — dependency-free (the suite avoids icon libraries inside
 * shared packages; apps pass their own icons where richer art is needed).
 * Geometry mirrors lucide's panel-top / maximize-2 / x / pin / chevron-down
 * so the reference look (pik) stays identical.
 */

interface IconProps {
  size?: number;
  className?: string;
}

const base = (size: number, className?: string) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  className,
  'aria-hidden': true,
});

export const PanelTopIcon = ({ size = 13, className }: IconProps) => (
  <svg {...base(size, className)}>
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <line x1="3" x2="21" y1="9" y2="9" />
  </svg>
);

export const MaximizeIcon = ({ size = 13, className }: IconProps) => (
  <svg {...base(size, className)}>
    <polyline points="15 3 21 3 21 9" />
    <polyline points="9 21 3 21 3 15" />
    <line x1="21" x2="14" y1="3" y2="10" />
    <line x1="3" x2="10" y1="21" y2="14" />
    <line x1="21" x2="14" y1="21" y2="14" />
    <line x1="3" x2="10" y1="3" y2="10" />
  </svg>
);

export const CloseIcon = ({ size = 13, className }: IconProps) => (
  <svg {...base(size, className)}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

export const PinIcon = ({ size = 11, className }: IconProps) => (
  <svg {...base(size, className)}>
    <line x1="12" x2="12" y1="17" y2="22" />
    <path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1z" />
  </svg>
);

export const ChevronDownIcon = ({ size = 12, className }: IconProps) => (
  <svg {...base(size, className)}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);
